import { Container } from "react-bootstrap";
import "./Footer.css";

const FOOTER_NAV = [
  { label: "How it works", href: "/#how-it-works" },
  { label: "Pricing", href: "/#pricing-plans" },
  { label: "Results", href: "/#results" },
  { label: "Team", href: "/#team" },
  { label: "Blog", href: "/#blogs" },
  { label: "Contact", href: "/#contact" },
  { label: "Contact", href: "/#contact" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms & Conditions", href: "/terms" },
];

const Footer = () => {
  return (
    <footer>
      {/* ── Social strip ── */}
     

      {/* ── Bottom footer ── */}
      <div className="footer-bottom">
        <Container>
          <div className="footer-bottom-top">
            {/* Brand */}
            <a href="/" className="footer-brand-wrap">
              <img
                src="./logo.jpeg"
                alt="SeenByAI"
                className="footer-brand-logo dark-mode-logo"
              />
              <img
                src="./seenbyailogowbg.png"
                alt="SeenByAI"
                className="footer-brand-logo light-mode-logo"
              />
              {/* <span className="footer-brand-name">SeenByAI</span> */}
            </a>

            {/* Nav links */}
            <nav className="footer-nav" aria-label="Footer navigation">
              {FOOTER_NAV.map(({ label, href }, i) => (
                <a key={i} href={href} className="footer-nav-link">
                  {label}
                </a>
              ))}
            </nav>
          </div>

          {/* Copyright */}
          <p className="footer-copyright">
            © {new Date().getFullYear()} SeenByAI · AI Visibility Intelligence ·
            seenbyai.ai
          </p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
